import { makeStyles } from "@material-ui/core"
import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	input: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		borderRadius: "3px",
		"& svg": {
			marginLeft: theme.spacing(1)
		},
		"&::before": {
			borderBottom: "none"
		}
	},
	closeChat: {
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor("transparent")
		}
	}
}))

export default useStyles
